import React, {useState} from "react";
import Modal from "UI/Modal";
import Button from "UI/Button/Button";

export default function ShareNowModal({open, onConfirm, onClose})
{
    const [busy, setBusy] = useState(false);

    const onPost = () => {
        setBusy(true);

        onConfirm().then(onClose);
    };

    return <Modal open={open} onClose={onClose} className='max-w-md'>
        <Modal.Header>
            Are you sure?
        </Modal.Header>
        <Modal.Content className="text-sm text-gray-500">
            Are you sure you wish to share this Post??
        </Modal.Content>
        <Modal.Footer>
            <Button busy={busy} type='danger' onClick={onPost}>Post</Button>
            <Button disabled={busy} onClick={onClose}>Cancel</Button>
        </Modal.Footer>
    </Modal>;
}